import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Icon from '../../../../common/components/Icon/Icon';
import './InternalNotifications.scss';
import Reminders from './Reminders/Reminders';
import Announcements from './Announcements/Announcements';
import Notifications from './Notifications/Notifications';
import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import {
  hasPermission,
  isBroker,
  isBrokerOrganisation,
} from '../../../auth/redux/authActions';
import { actions } from '../../../dashboard/redux/dashboardActions';
import { bindActionCreators } from 'redux';

class DropDown extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    counter: PropTypes.number.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    // Dropdown block is inactive & hidden by default
    this.state = {
      dropdownIsActive: false,
      dropdownIsVisible: false,
    };

    this._hideDropdown = this._hideDropdown.bind(this);
    this._handleBlur = this._handleBlur.bind(this);
    this._handleFocus = this._handleFocus.bind(this);
    this._openDropdown = this._openDropdown.bind(this);
  }

  componentDidMount() {
    // Hide dropdown block on click outside the block
    window.addEventListener('click', this._hideDropdown, false);
  }

  componentWillUnmount() {
    // Remove click event listener on component unmount
    window.removeEventListener('click', this._hideDropdown, false);
  }

  _stopPropagation(e) {
    // Stop bubbling of click event on click inside the dropdown content
    e.stopPropagation();
  }

  _openDropdown() {
    this.setState({ dropdownIsVisible: true });
  }

  _hideDropdown() {
    const { dropdownIsActive } = this.state;

    if (!dropdownIsActive) {
      this.setState({ dropdownIsVisible: false });
    }
  }

  _handleFocus() {
    // Make active on focus
    this.setState({ dropdownIsActive: true });
  }

  _handleBlur() {
    // Clean up everything on blur
    this.setState({
      dropdownIsVisible: false,
      dropdownIsActive: false,
    });
  }

  render() {
    const { dropdownIsVisible } = this.state;
    return (
      <div onFocus={this._handleFocus} onClick={this._openDropdown}>
        <span className="toggler">
          <Button className="icon-bt">

            <Icon className="notification-icon" name={this.props.content.icon} />
            <span className="badge">{this.props.counter}</span>
          </Button>
        </span>

        {dropdownIsVisible && (
          <div className={'dropdown-' + this.props.content.name}>
            <div>
              <span className="close-area" onClick={this._handleBlur} />
              {this.props.content.dropdown}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const itemNotification = {
  content: {
    name: 'notifications',
    icon: 'comment-dots',
    dropdown: (
      <div>
        <h3> Notifications </h3>
        <Notifications />
      </div>
    ),
  },
};
const itemReminders = {
  content: {
    name: 'reminders',
    icon: 'bell',
    dropdown: (
      <div>
        <h3> Reminders </h3>
        <Reminders />
      </div>
    ),
  },
};
const itemAnnouncements = {
  content: {
    name: 'announcements',
    icon: 'bullhorn',
    dropdown: (
      <div>
        <h3> Announcements </h3>
        <Announcements />
      </div>
    ),
  },
};

export class InternalNotifications extends Component {
  componentDidMount() {
    const { dashboard, actions } = this.props;
    if (!dashboard.lastUpdated) {
      actions.fetchStats();
    } else {
      const now = moment();
      if (now.diff(dashboard.lastUpdated, 'minutes') > 10) {
        actions.fetchStats();
      }
    }
  }

  render() {
    const { dashboard } = this.props;
    const notificationsTotal = get(dashboard.stats, 'meta.notification_count', 0);
    const announcementsTotal = get(dashboard.stats, 'meta.announcement_count', 0);
    const remindersTotal = get(dashboard.stats, 'meta.reminder_count', 0);

    return (
      <div>
        {isBroker() || isBrokerOrganisation() ? (
          <>
            <div className="notification-bar-notifications">
              <DropDown
                id={1}
                counter={notificationsTotal}
                content={itemNotification.content}
              />
            </div>
            <div className="notification-bar-reminder">
              <DropDown id={2} counter={remindersTotal} content={itemReminders.content} />
            </div>

            {/*<div className="notification-bar-announcements">*/}
            {/*  <DropDown*/}
            {/*    id={3}*/}
            {/*    counter={announcementsTotal}*/}
            {/*    content={itemAnnouncements.content}*/}
            {/*  />*/}
            {/*</div>*/}
          </>
        ) : (
          <>
            <div className="notification-bar-reminder">
              <DropDown id={2} counter={remindersTotal} content={itemReminders.content} />
            </div>
            {hasPermission('content_management.view_announcement_feature') && (
              <div className="notification-bar-announcements">
                <DropDown
                  id={3}
                  counter={announcementsTotal}
                  content={itemAnnouncements.content}
                />
              </div>
            )}
            <div className="notification-bar-notifications">
              <DropDown
                id={1}
                counter={notificationsTotal}
                content={itemNotification.content}
              />
            </div>
          </>
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    dashboard: state.dashboard,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(InternalNotifications);
